// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 520px;
}

mat-dialog-content {
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.button-gap { gap: 12px; }

.btn::after { content: '' !important; display: none !important; }

.metrics-tree {
  font-size: 14px;
  display: table;
  width: 100%;
}

.metrics-group {
  display: table-row-group;
  margin-bottom: 6px;
}

.metrics-row {
  display: table-row;
  padding: 2px 0;
}

.metrics-name {
  display: table-cell;
  padding: 2px 16px 2px 0;
  white-space: nowrap;
}

.metrics-count {
  display: table-cell;
  color: #0b2d71;
  padding: 2px 0;
  text-align: left;
  white-space: nowrap;
}

.metrics-children {
  display: contents;
}

.metrics-child-row .metrics-name {
  padding-left: 24px;
  color: #444;
}

.metrics-child-row .metrics-count {
  color: #0b2d71;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/tools/metrics/metrics.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,cAAc,SAAS,EAAE;;AAEzB,cAAc,sBAAsB,EAAE,wBAAwB,EAAE;;AAEhE;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB","sourcesContent":[":host {\n  display: block;\n  min-width: 520px;\n}\n\nmat-dialog-content {\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.button-gap { gap: 12px; }\n\n.btn::after { content: '' !important; display: none !important; }\n\n.metrics-tree {\n  font-size: 14px;\n  display: table;\n  width: 100%;\n}\n\n.metrics-group {\n  display: table-row-group;\n  margin-bottom: 6px;\n}\n\n.metrics-row {\n  display: table-row;\n  padding: 2px 0;\n}\n\n.metrics-name {\n  display: table-cell;\n  padding: 2px 16px 2px 0;\n  white-space: nowrap;\n}\n\n.metrics-count {\n  display: table-cell;\n  color: #0b2d71;\n  padding: 2px 0;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.metrics-children {\n  display: contents;\n}\n\n.metrics-child-row .metrics-name {\n  padding-left: 24px;\n  color: #444;\n}\n\n.metrics-child-row .metrics-count {\n  color: #0b2d71;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
